<template>
    <div>
        <h1>TEST</h1>
        <div>
            <button @click="onLogin">button</button>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
import mainDelegate from '@/delegate/mainDelegate'
export default {
    mixins: [mainDelegate],
    methods: {
        onLogin() {
            this.loginApi({
                Username: 'Member',
                Password: '1234'
            })
        }
    }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/page/Test.vue